<template>
  <div class="login" :class="brandClass">

    <header class="header">
      <div class="container1200">
        <div class="logo-nav">
          <img :src="navLogoSrc" class="logo-src" alt="logo" />
          <!-- <div class="logo-placeholder">LOGO</div>
          <span class="brand-name">{{ brandName }}</span>
          <span class="brand-domain">bmguanjia.com</span> -->

          <nav class="nav-menu">
            <router-link tag="a" to="/">主页</router-link>
            <router-link tag="a" to="/#scene">功能介绍</router-link>
            <router-link tag="a" to="/#steps">使用场景</router-link>
            <router-link tag="a" to="/#about">关于我们</router-link>
          </nav>
          <button class="login-btn">
            {{ loginBtnText }}
          </button>
        </div>
      </div>
    </header>
    <div class="login-wrapper">
          <div class="mylogin" @click="submitForm()">
      <el-image
        v-if="copyrightConfig.AppID === 'wx1e899bddb256a5ca'"
        class="left-image"
        src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/jljiajia-login-bg.jpg"
      ></el-image>
      <el-image
        v-if="copyrightConfig.AppID === 'wx7d8daf6d777947a2'"
        class="left-image"
        src="https://ossfastmake.mustke.com//12jielong/lsyJL/bmgjPcLogin.jpg"
      ></el-image>
      <div class="code-back">
        <div class="login-text">微信扫码登录</div>
        <div style="text-align: center">
          <div
            class="code-image"
            v-show="loading"
            style="display: inline-block"
            v-loading="loading"
          ></div>
          <el-image
            v-if="!loading"
            class="code-image"
            :src="codeUrl"
            v-loading="loading"
          ></el-image>
          <div class="login-bottom-text" v-show="!loading">
            微信扫一扫，快速登录
          </div>
        </div>
      </div>
    </div>
    </div>

    <div class="login-footer">
      <div class="container1200">
        <div class="footer-wrapper">
          <div class="footer-left">
            <div class="footer-title">关于我们</div>
            <div class="footer-subtitle"> {{brandName}}——对接龙市场需求变化、全新设计的一款微信小程序，体积小巧，功能全面，使用方便</div>
          </div>
          <div class="footer-right">
            <div class="right-item">
              <div class="item-title">小程序二维码</div>
              <div class="item-qrcode">
                <img :src="qrcodeSrc" alt="">
              </div>
            </div>
            <div class="right-item">
              <div class="item-title">客服微信</div>
              <div class="item-qrcode">
                <img :src="customerSrc" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../../router/index";

import { getLoginCode, checkLoginCode, LogOut } from "@/utils/api/user";
import copyrightConfig from "@/utils/config/changeCopyright.js";
export default {
  name: "Login",
  page() {
    return {
      title: '用户登录'
    };
  },
  data: function () {

    // 判断品牌
    const isJL = copyrightConfig.AppID === "wx1e899bddb256a5ca";
    const token = localStorage.getItem("token");

    return {
      codeUrl: "",
      timer: null,
      loginKey: "",
      loading: true,
      copyrightConfig, // 新增
      loginBtnText: token ? "管理中心" : "登录/注册",
      brandClass: isJL ? "brand-main-jl" : "brand-main-bmgj",
      brandName: isJL ? "接龙加加" : "报名管家",
      // 图片路径
      navLogoSrc: isJL
        ? require("@/assets/images/bmgj/jljj-tab-pc.svg")
        : require("@/assets/images/bmgj/bmgj-tab-pc.svg"),

      qrcodeSrc: isJL
        ? require("@/assets/images/imageLand/pc_ewm.png")
        : require("@/assets/images/bmgj/bmewm.jpg"),

      customerSrc: isJL
        ? "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/lsyJL/jljj_kf_new.png"
        : "https://ossfastmake.mustke.com//12jielong/bdJL/bmkfblue.png"

    };
  },

  created() {
    this.getCode();

    this.timer = window.setInterval(() => {
      setTimeout(() => {
        this.checkCode(); //调用接口的方法
        // console.log(1111111111);
      }, 0);
    }, 3000);
  },

  methods: {
    getCode() {
      var that = this;

      getLoginCode({
        appId: copyrightConfig.AppID,
      })
        .then((res) => {
          console.log(res, "res");
          if (res.status == 0) {
            // 已经登录，退出登录
            this.$message(res.msg);
            LogOut().then(() => {
              localStorage.removeItem("user");
              localStorage.removeItem("token");
              router.push("/login");
            });
          } else {
            that.codeUrl = "data:image/png;base64," + res.data.code;
            // that.codeUrl = res.data.code;
            that.loginKey = res.data.loginKey;
          }
        })
        .catch((error) => {
          console.log(error, "error");
        })
        .finally(() => {
          that.loading = false;
        });
    },

    checkCode() {
      if (this.loginKey != "") {
        checkLoginCode({ loginKey: this.loginKey })
          .then((res) => {
            console.log(res, "轮询结果");
            if (res.msg.length > 1) {
              // 已授权
              var nstr = res.msg.split(",");
              var token = nstr[nstr.length - 1];
              console.log(res, "已经登录信息");
              console.log(token, "授权结果token");
              window.clearInterval(this.timer);

              if (token == "小程序码已失效，请刷新") {
                this.$message("小程序码已失效，请刷新");
              } else {
                localStorage.setItem("user", JSON.stringify("用户昵称"));
                localStorage.setItem("token", token);
                router.push("/home");
              }
            }
          })
          .catch((error) => {
            console.log(error, "error");
          });
      }
    },
    submitForm() {
      return;
      // localStorage.setItem("user", JSON.stringify("2222"));
      // router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100vw;
  padding: 0;
  margin: 0;
  height: 100vh;
  font-size: 16px;
  background-position: left top;
  background-color: #f6f7fa;
  display: flex;
  flex-direction: column;
  position: relative;
}
.login-wrapper{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mylogin {
  width: 815px;
  height: 502px;
  // position: absolute;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  // margin: auto;
  display: flex;
  background: #ffffff;
  box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.15);

  border-radius: 15px;
  overflow: hidden;
}

.left-image {
  width: 371px;
  height: 502px;
}

.code-back {
  width: 498px;
  height: 502px;
}

.login-text {
  font-size: 22px;
  font-weight: Bold;
  text-align: left;
  color: #2a3762;
  line-height: 29px;
  margin-left: 28px;
  margin-top: 75px;
}

.code-image {
  width: 180px;
  height: 177px;
  margin-top: 59px;
}

.login-bottom-text {
  font-size: 14px;
  margin-top: 18px;
  color: #596178;
}

.brand-main-jl {
  --main-color: #2d53c5;
  cursor: pointer;
}
.brand-main-bmgj {
  --main-color: #2578e3;
  cursor: pointer;
}
.fixed-header {
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  cursor: pointer;
}
.container1200 {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
}
.header {
  height: 60px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  padding: 0;
  background: #fff;
  z-index: 100;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06)
}
.logo-nav {
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
}
.logo-src {
  height: 25px;
  cursor: pointer;
  margin-left: 65px;
}
.logo-placeholder {
  width: 80px;
  height: 36px;
  background: #e0e0e0;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
}

.brand-name {
  font-size: 20px;
  font-weight: bold;
  margin-left: 8px;
  color: var(--main-color);
}
.brand-domain {
  margin-left: 8px;
  color: #343a40;
  font-size: 16px;
}
.nav-menu {
  flex: 1;
  display: flex;
  justify-content: center;
  gap: 40px;
}
.nav-menu a {
  color: #222;
  font-size: 16px;
  text-decoration: none;
  transition: color 0.2s;
}
.nav-menu a:hover,
.nav-menu a:active {
  color: var(--main-color);
}
.login-btn {
  background: var(--main-color);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 24px;
  font-size: 16px;
  margin-left: auto;
  cursor: pointer;
  transition: background 0.2s;
}
.login-btn:hover {
  background: #1d357a;
}
.login-footer{
  // position: absolute;
  // left: 0;
  // right: 0;
  // bottom: 0;
  background-color: #0a1229;
  .footer-wrapper{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
  }
  .footer-left{
    font-size: 16px;
    color: #fff;
    position: relative;
    top: -20px;
    padding-left: 52px;
  }
  .footer-subtitle{
    margin-top: 10px;
    font-size: 14px;
    color: #fff;
  }
  .footer-right{
    display: flex;
    gap: 20px;
    .right-item{
      .item-title{
        font-size: 14px;
        color: #fff;
        margin-bottom: 5px;
        text-align: center;
      }
      .item-qrcode{
        img{
          width: 90px;
          height: 90px;
        }
      }
    }
  }
}
</style>
